import React from "react";
import {
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Box,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

const CrmTable = () => {
  const { data, loading, error } = useFetchWithAuth(
    "/statistic/operator/crm-statistic/"
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!data) return null;
  return (
    <Card
      sx={{
        background: "var(--whiteColor)",
        color: "var(--blackColor)",
        borderRadius: 3,
        p: 3,
        mb: 3,
        boxShadow: "none",
      }}
    >
      <Typography
        sx={{
          color: "var(--blackColor)",
          fontWeight: 700,
          fontSize: 22,
          mb: 3,
          ".dark-theme &": { color: "var(--whiteColor)" },
        }}
      >
        Доступні CRM
      </Typography>
      <Box
        sx={{
          borderRadius: "10px 10px 0 0",
          overflow: "hidden",
          marginTop: "10px",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "var(--blackColor)",
                  fontWeight: 600,
                  fontSize: 16,
                  border: 0,
                  py: 2,
                  ".dark-theme &": { color: "var(--whiteColor)" },
                }}
              >
                Назва
              </TableCell>
              <TableCell
                sx={{
                  color: "var(--blackColor)",
                  fontWeight: 600,
                  fontSize: 16,
                  border: 0,
                  py: 2,
                  ".dark-theme &": { color: "var(--whiteColor)" },
                }}
              >
                Середній чек
              </TableCell>
              <TableCell
                sx={{
                  color: "var(--blackColor)",
                  fontWeight: 600,
                  fontSize: 16,
                  border: 0,
                  py: 2,
                  ".dark-theme &": { color: "var(--whiteColor)" },
                }}
              >
                % допродажу
              </TableCell>
              <TableCell
                sx={{
                  color: "var(--blackColor)",
                  fontWeight: 600,
                  fontSize: 16,
                  border: 0,
                  py: 2,
                  ".dark-theme &": { color: "var(--whiteColor)" },
                }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.data &&
              data.data.map((row, idx) => (
                <TableRow
                  key={idx}
                  sx={{
                    background: "var(--whiteColor)",
                    borderBottom: "1px solid var(--borderColor)",
                    ".dark-theme &": {
                      background: "var(--darkCardBg)",
                      borderBottom: "1px solid var(--darkBorder)",
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      color: "var(--blackColor)",
                      border: 0,
                      py: 2,
                      fontSize: 15,
                      ".dark-theme &": { color: "var(--whiteColor)" },
                    }}
                  >
                    {row.crm_name}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "var(--blackColor)",
                      border: 0,
                      py: 2,
                      fontSize: 15,
                      ".dark-theme &": { color: "var(--whiteColor)" },
                    }}
                  >
                    {row.avg_check}₴
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "var(--blackColor)",
                      border: 0,
                      py: 2,
                      fontSize: 15,
                      ".dark-theme &": { color: "var(--whiteColor)" },
                    }}
                  >
                    {row.upsell_percent}
                  </TableCell>
                  <TableCell sx={{ border: 0, p: 0 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        mr: 2,
                      }}
                    ></Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
    </Card>
  );
};
export default CrmTable;
